import './index.css';
const tooltipIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 -5 21 30">
  <path fill="currentColor" d="M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4M6,7H18V9H6V7M6,11H16V13H6V11Z" />
</svg>`;

export default class Tooltip {
  static get isInline() {
    return true;
  }

  static rehydrateAll(api) {
    const tooltips = document.querySelectorAll('.cdx-tooltip');
    tooltips.forEach(span => {
      const value = span.dataset.tooltip;
      if (value) {
        api.tooltip.onHover(span, value, {
          placement: api.configuration.tools.tooltip.config.location,
          hidingDelay: api.configuration.tools.tooltip.config.hidingDelay
        });
      }
    });
  }
  
  get state() {
    return this._state;
  }

  set state(state) {
    this._state = state;
    const { button } = this;
    const { inlineToolButtonActive } = this.api.styles;
    button.classList.toggle(inlineToolButtonActive, state);
  }

  constructor({ api, config = {} }) {
    this.api = api;
    this.button = null;
    this._state = false;
    this.spanTooltip = null;

    const { location = 'bottom' } = config;
    this.tooltipLocation = location;
    this.highlightColor = config.highlightColor;
    this.underline = config.underline ?? false;
    this.backgroundColor = config.backgroundColor;
    this.textColor = config.textColor;
    this.editorId = config.holder ?? 'editorjs';
    this.placeholder = config.placeholder ?? 'Add a tooltip';

    this.tag = 'SPAN';

    this.CSS = {
      input: 'tooltip-tool__input',
      tooltip: 'cdx-tooltip',
      span: 'tooltip-tool__span',
      underline: 'tooltip-tool__underline',
    };

    this.tooltipsObserver();
  }

  createTooltip(tooltipValue, spanTooltip = this.api.selection.findParentTag(this.tag, this.CSS.tooltip)) {
    if (!spanTooltip) return;
    spanTooltip.dataset.tooltip = tooltipValue;
    this.setBackgroundColor(spanTooltip);
    this.setUnderlineDecoration(spanTooltip);
    this.api.tooltip.onHover(spanTooltip, tooltipValue, {
      placement: this.tooltipLocation,
      hidingDelay: 1000
    });
  }

  render() {
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.innerHTML = tooltipIcon;
    const { inlineToolButton } = this.api.styles;
    this.button.classList.add(inlineToolButton);
    return this.button;
  }

  surround(range) {
    if (this.state && this.spanTooltip) {
      this.unwrap(range);
      this.api.toolbar.close();
      return;
    }
  
    if (this.state) {
      this.tooltipInput?.focus(); // só foca se já estiver aplicado
      return;
    }
  
    this.wrap(range);
    this.state = true;
    this.api.selection.expandToTag(this.spanTooltip);
    this.showActions();
  }

  wrap(range) {
    const selectedText = range.extractContents();
    this.spanTooltip = document.createElement(this.tag);
    this.spanTooltip.classList.add(this.CSS.tooltip);
    this.spanTooltip.appendChild(selectedText);
    range.insertNode(this.spanTooltip);
    this.api.selection.expandToTag(this.spanTooltip);
  }

  unwrap(range) {
    this.spanTooltip = this.api.selection.findParentTag(this.tag, this.CSS.tooltip);
    if (!this.spanTooltip) return;
    const text = range.extractContents();
    this.spanTooltip.remove();
    range.insertNode(text);
    this.state = false;
  }

  checkState() {
    const tag = this.api.selection.findParentTag(this.tag, this.CSS.tooltip);
    this.state = !!tag;
  
    if (this.state) {
      this.spanTooltip = tag;
  
      this.ensureTooltipInput(); // garante que o input exista
  
      this.tooltipInput.value = tag.dataset.tooltip || '';
      this.tooltipInput.hidden = false;
  
      setTimeout(() => {
        this.tooltipInput.focus();
        this.tooltipInput.select();
      }, 50);
    }
  }
  
  ensureTooltipInput() {
    if (!this.tooltipInput) {
      this.tooltipInput = document.createElement('input');
      this.tooltipInput.placeholder = this.placeholder;
      this.tooltipInput.classList.add(this.api.styles.input, this.CSS.input);
      this.tooltipInput.type = 'text';
  
      this.api.listeners.on(this.tooltipInput, 'keydown', (e) => {
        if (e.key === 'Enter') {
          const tooltipValue = this.tooltipInput.value.trim();
  
          const currentSpan = this.api.selection.findParentTag(this.tag, this.CSS.tooltip);
          if (!tooltipValue && currentSpan) {
            const range = document.createRange();
            range.selectNodeContents(currentSpan);
            const contents = range.extractContents();
            currentSpan.replaceWith(contents);
            this.api.toolbar.close();
            this.state = false;
            return;
          }
  
          this.createTooltip(tooltipValue, currentSpan);
          this.api.toolbar.close();
          this.tooltipInput.blur();
        }
      });
    }
  }  

  renderActions() {
    this.ensureTooltipInput();
    this.checkState();
    return this.tooltipInput;
  }
  
  showActions() {
    const currentSpan = this.api.selection.findParentTag(this.tag, this.CSS.tooltip);
  
    setTimeout(() => {
      this.tooltipInput?.focus();
    }, 50);
  
    this.api.listeners.on(this.tooltipInput, 'keydown', (e) => {
      if (e.key === 'Enter') {
        const tooltipValue = this.tooltipInput.value.trim();
        
        if (!tooltipValue && currentSpan) {
          // Se não tem conteúdo, remove o span
          const range = document.createRange();
          range.selectNodeContents(currentSpan);
          const contents = range.extractContents();
          currentSpan.replaceWith(contents);
        
          this.api.toolbar.close();
          this.state = false;
          return;
        }

        this.createTooltip(tooltipValue, currentSpan);
  
        this.api.toolbar.close();
        this.tooltipInput.blur();
      }
    });
  }
  
  
  hideActions() {
    if (this.tooltipInput) this.tooltipInput.hidden = true;
  }

  tooltipsObserver() {
    const holder = document.getElementById(this.editorId);
    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.target.classList.contains('codex-editor__redactor')) {
          const spanTooltips = document.querySelectorAll('.cdx-tooltip');
          spanTooltips.forEach((span) => this.createTooltip(span.dataset.tooltip, span));
        }
      });
    });
    observer.observe(holder, { childList: true, subtree: true });
  }

  setBackgroundColor(spanTooltip) {
    const tooltip = spanTooltip;
    if (tooltip.childElementCount > 0) {
      tooltip.firstChild.classList.add(this.CSS.span);
      tooltip.firstChild.style.background = this.highlightColor;
    } else {
      tooltip.classList.add(this.CSS.span);
      tooltip.style.background = this.highlightColor;
    }
  }

  setUnderlineDecoration(spanTooltip) {
    if (!this.underline) return;
    const tooltip = spanTooltip;
    (tooltip.childElementCount > 0)
      ? tooltip.firstChild.classList.add(this.CSS.underline)
      : tooltip.classList.add(this.CSS.underline);
  }

  static get sanitize() {
    return {
      span: {
        class: true,
        "data-tooltip": true,
        style: true
      }
    };
  }  
}